import Chip from "features/components/Chip";

interface UploadedFileProps {
  fileName: string;
  onClear?: () => void;
  canDelete?: boolean;
  errorMessage?: string;
}

const UploadedFile = ({
  fileName,
  onClear,
  canDelete = true,
  errorMessage,
}: UploadedFileProps) => (
  <Chip
    label={
      <span className="flex min-w-0 items-center gap-1">
        <span className="min-w-0 truncate">{errorMessage ?? fileName}</span>
      </span>
    }
    onDelete={canDelete && onClear ? onClear : undefined}
    size="medium"
    color={errorMessage ? "error" : "default"}
    sx={{ maxWidth: 160 }}
  />
);

export default UploadedFile;
